<span *ngIf="entry?.packagenb"> {{ entry?.packagenb }}x boîte</span>
<span *ngIf="entry?.perday"> {{ entry?.perday }}x par jour</span>
<span *ngIf="entry?.everydays"> Tous les {{ entry?.everydays }} jour(s)</span>
<span *ngIf="entry?.days"> Pendant {{ entry?.days }} jour(s)</span>
<span *ngIf="entry?.poso2"> {{ entry?.poso2 }} le matin</span>
<span *ngIf="entry?.poso4"> {{ entry?.poso4 }} à 10h</span>
<span *ngIf="entry?.poso6"> {{ entry?.poso6 }} le midi</span>
<span *ngIf="entry?.poso8"> {{ entry?.poso8 }} à 16h</span>
<span *ngIf="entry?.poso10"> {{ entry?.poso10 }} le soir</span>
<span *ngIf="entry?.poso12"> {{ entry?.poso12 }} au coucher</span>
<span *ngIf="entry?.Chronic"> Chronique</span>
<div *ngIf="entry?.Comment">{{ entry.Comment }}</div>
